export class ChangePassword {
    UserToken: string;
    OrganisationID : number;
    MemberID : number;
    ContactID : number;
    Password : string;
    WasSuccessful : string;
    Exception : string;
}
